import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar PWA
serviceWorkerRegistration.register({
  onUpdate: registration => {
    const confirmUpdate = window.confirm(
      '🔄 Hay una nueva versión disponible. ¿Deseas actualizar ahora?'
    );
    if (confirmUpdate && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
  onSuccess: () => {
    console.log('✅ App instalada y lista para offline');
  }
});
